<!-- 
  说明： 
  1. 图表修改： 图表需要加上 mousedown 事件和class link 例子： Gauge2Charts组件
  2. 图表属性添加： 图表 Configuration 里需要添加链接配置属性 例子： Gauge2Charts组件
  3. 每一个风格的 bottom 组件都需要修改，只需要把每一个 menu-item 绑定一个唯一的 id，
    即场景的id。 例子：V3StyleBottom 组件
 -->
<template>
  <!-- 图表链接配置 -->
  <div class='ChartsLinkConfiger'>
    <div class="p-line"></div>
    <div class="p-name">图表链接配置 <span class="p-span">(仅在预览或发布生效)</span></div>
    <div class="p-grid">
      <!-- 开启链接 -->
      <div class="is-open-link">
        <p>是否开启链接跳转</p>
        <el-switch v-model="value.isOpenLink" active-color="#1989fa" size="mini" inactive-color="#333"
          @change="changeSetting">
        </el-switch>
      </div>
      <!-- 内外链场景跳转 -->
      <div class="inner-outer-link" v-if="value.isOpenLink">
        <!-- 内外链选择，默认内链 -->
        <div class="is-open-outer-link">
          <p>内外链接选择</p>
          <div class="btns">
            <el-button type="default" :class="{
              active: value.linkType == 'inner',
            }" size="mini" @click="handleChangeLinkType('inner')">
              <i class="el-icon-link"></i>
              <span class="button-text">内链场景</span>
            </el-button>
            <el-button type="default" :class="{
              active: value.linkType == 'outer',
            }" size="mini" @click="handleChangeLinkType('outer')">
              <i class="el-icon-link"></i>
              <span class="button-text">外链地址</span>
            </el-button>
          </div>
        </div>
        <!-- 内链选择 -->
        <div class="inner-choose" v-show="value.linkType == 'inner'">
          <p>选择场景</p>
          <el-select v-model="value.linkUrl" size="mini" placeholder="请选择" @change="handleSceneChange">
            <el-option v-for="item in sceneList" :key="item.id" :label="item.sceneName" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 外联选择 -->
        <div class="outer-choose" v-show="value.linkType == 'outer'">
          <p>链接</p>
          <el-input size="mini" v-model="url" placeholder="请填写链接" @blur="urlBlur"></el-input>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ChartsLinkConfiger',
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      // sceneList:[], // 场景
      value: {
        isOpenLink: false,
        linkType: 'inner',
        linkUrl: ''
      }, // 链接对象
      url:'', // 临时链接
    }
  },
  computed: {
    ...mapState({
      sceneList: state => {
        return state.ProjectInfo.SceneryList.map(item => {
          return {
            sceneName: item.SceneName,
            id: item.id
          }
        })
      }
    })
  },
  watch: {
    value: {
      deep: true,
      handler: function (nV) {
        console.log();
        this.commitCurrentPropertyData(nV)
      }

    }
  },
  components: {
  },
  created() {
    console.log('wwwwwww');
    this.initCurrentPropertyData();
  },
  mounted() {

  },
  methods: {
    handleSceneChange(){

    },
    // 地址失去焦点赋值
    urlBlur(e){
      console.log(e.target.value);
      this.value.linkUrl = e.target.value
    },
    // 关闭链接后数据重置
    changeSetting(val){
      console.log(val);
      if(!val){
        this.value.linkType = 'inner'
        this.value.linkUrl = ''
      }
    },
    // 链接类型改变后，url重置
    handleChangeLinkType(type) {
      this.url = ''
      this.value.linkType = type
      
    },
    initCurrentPropertyData() {
      this.value = this.$_.cloneDeep(this.propertyData[this.propertyDataKey].value);
      this.url = this.value.linkUrl
    },
    commitCurrentPropertyData(val) {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
  },
}
</script>

<style lang='scss' scoped>
.ChartsLinkConfiger {
  margin-top: 10px;
  height: auto;
  transition: all 0.2s ease-in-out;
  width: 100%;
  box-sizing: border-box;
  .p-span{
    font-size: $property-attributes-size;
  }

  .p-line {
    width: 100%;
    height: 1px;
    background-image: linear-gradient(to left,
        rgba(204, 204, 204, 0),
        rgb(143, 143, 143),
        rgba(204, 204, 204, 0));
    margin-bottom: 5px;
  }

  .p-name {
    color: $property-title-color;
    font-size: $property-title-size;
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    line-height: 30px;
  }

  .p-grid {
    margin: 5px 0;
    color: $property-attributes-color;
    font-size: $property-attributes-size;
    width: 100%;
    // height: 30px;
    // box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    align-items: center;
    justify-content: space-between;

    .inner-outer-link {
      width: 100%;

      // background: red;
      .is-open-outer-link {
        margin-top: 10px;
        // padding: 0 15px;
        .btns {
          width: 100%;
          // position: relative;
          // box-sizing: border-box;
          display: flex;
          justify-content: center;
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          padding: 10px 10px 0 10px;
          justify-content: space-between;
          font-size: 14px;

          .el-button {
            height: 33px;
            border-radius: 5px;
            color: #b6b8cc;
            border: 0;
            padding: 0 15px;
            background: #2c2e3f;

            &:hover {
              background: linear-gradient(143deg, #335ae9, #6f6ff5);
              color: white;
            }

            display: flex;
            align-items: center;
          }

          .el-icon-link {
            font-size: 16px;
          }
        }


      }

      .inner-choose,
      .outer-choose {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }


    .el-input {
      width: 192px;
    }

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);

      &:hover {
        border: 1px solid #3179ff;
      }

      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }

  .is-open-link {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

}

// 切换
:deep().el-switch {
  margin: auto 0;

  .el-switch__core {
    background: #55597b;
    border: none;
    height: 10px;
    width: 30px !important;

    .el-switch__action {
      top: -2px;

      background: #c9cae5;

      width: 14px;
      height: 14px;
    }
  }

  &.is-checked {
    .el-switch__core {
      background: linear-gradient(143deg, #335ae9, #6f6ff5);

      .el-switch__action {
        left: 100%;
        background: #ffffff;
        margin-left: -14px;
      }
    }
  }
}

// 按钮激活
.active {
  background: linear-gradient(143deg, #335ae9, #6f6ff5)!important;
  color: white!important;
}
</style>